import { EditOutlined } from '@ant-design/icons'
import { Button, Dropdown, Flex } from 'antd'
import { MenuProps, FlexProps } from 'antd/lib'

import { useStyles } from './styles'

type Props = {
  items: MenuProps['items']
} & Omit<FlexProps, 'children'>

export const TableActionButtons = ({ items, ...props }: Props) => {
  const { styles } = useStyles()

  if (!items?.length) return null

  return (
    <Flex justify="flex-end" {...props}>
      <Dropdown
        menu={{ items }}
        rootClassName={styles.dropdown}
        trigger={['click']}
      >
        <Button icon={<EditOutlined />} onClick={(e) => e.stopPropagation()} />
      </Dropdown>
    </Flex>
  )
}
